module.exports = __webpack_public_path__ + "img/tx-icon.d11f9527.svg";